import { useApp } from '@context/AppContext';

// Challenge Mode phases
import ChallengeLobby from './challenge/ChallengeLobby';
import ChallengeDrawing from './challenge/ChallengeDrawing';
import ChallengeReview from './challenge/ChallengeReview';
import ChallengeVoting from './challenge/ChallengeVoting';
import ChallengeResults from './challenge/ChallengeResults';
import DrawOff from './challenge/DrawOff';

// Relay Mode phases
import RelayLobby from './relay/RelayLobby';
import RelayActive from './relay/RelayActive';
import RelayTransition from './relay/RelayTransition';
import RelayFinished from './relay/RelayFinished';

// Squiggle Game phases
import SquiggleLobby from './squiggle/SquiggleLobby';
import SquiggleActive from './squiggle/SquiggleActive';
import SquigglePairReveal from './squiggle/SquigglePairReveal';
import SquiggleGallery from './squiggle/SquiggleGallery';
import SquiggleVoting from './squiggle/SquiggleVoting';
import SquiggleResults from './squiggle/SquiggleResults';

// Broken Telephone phases
import TelephoneLobby from './telephone/TelephoneLobby';
import TelephoneDrawing from './telephone/TelephoneDrawing';
import TelephoneGuessing from './telephone/TelephoneGuessing';
import TelephoneReveal from './telephone/TelephoneReveal';

// Exquisite Corpse phases
import CorpseLobby from './corpse/CorpseLobby';
import CorpseAssigning from './corpse/CorpseAssigning';
import CorpseDrawing from './corpse/CorpseDrawing';
import CorpseReveal from './corpse/CorpseReveal';
import CorpseGallery from './corpse/CorpseGallery';

/**
 * Phase-aware router that renders the correct game overlay.
 * Canvas stays mounted underneath — game UI layers on top.
 */
export default function GameRouter({ stageRef }) {
  const { state } = useApp();
  const { game } = state;

  if (!game.mode || game.phase === 'off') return null;

  // Challenge Mode
  if (game.mode === 'challenge') {
    switch (game.phase) {
      case 'lobby': return <ChallengeLobby />;
      case 'drawing': return <ChallengeDrawing stageRef={stageRef} />;
      case 'review': return <ChallengeReview />;
      case 'voting': return <ChallengeVoting />;
      case 'results': return <ChallengeResults />;
      case 'drawoff': return <DrawOff stageRef={stageRef} />;
      default: return null;
    }
  }

  // Relay Mode
  if (game.mode === 'relay') {
    switch (game.phase) {
      case 'lobby': return <RelayLobby />;
      case 'active': return <RelayActive />;
      case 'transition': return <RelayTransition />;
      case 'finished': return <RelayFinished stageRef={stageRef} />;
      default: return null;
    }
  }

  // Squiggle Game
  if (game.mode === 'squiggle') {
    switch (game.phase) {
      case 'lobby': return <SquiggleLobby />;
      case 'squiggling': return <SquiggleActive stageRef={stageRef} />;
      case 'transforming': return <SquiggleActive stageRef={stageRef} />;
      case 'pairReveal': return <SquigglePairReveal />;
      case 'gallery': return <SquiggleGallery />;
      case 'voting': return <SquiggleVoting />;
      case 'results': return <SquiggleResults />;
      default: return null;
    }
  }

  // Broken Telephone
  if (game.mode === 'telephone') {
    switch (game.phase) {
      case 'lobby': return <TelephoneLobby />;
      case 'drawing': return <TelephoneDrawing stageRef={stageRef} />;
      case 'guessing': return <TelephoneGuessing />;
      case 'reveal': return <TelephoneReveal />;
      default: return null;
    }
  }

  // Exquisite Corpse
  if (game.mode === 'corpse') {
    switch (game.phase) {
      case 'lobby': return <CorpseLobby />;
      case 'assigning': return <CorpseAssigning />;
      case 'drawing': return <CorpseDrawing stageRef={stageRef} />;
      case 'reveal': return <CorpseReveal stageRef={stageRef} />;
      case 'gallery': return <CorpseGallery />;
      default: return null;
    }
  }

  return null;
}
